export default __webpack_public_path__ + "static/media/img_weblogic-colorBkg.20eb95b7.png";